export const getPrintMode = (store: any): boolean => {
    return store.printMode;
};
